<template>
    <div class="detaioBread">
        <div class="detaioBread_">
            <em @click="goback">智慧后勤建设</em> <i class="el-icon-arrow-right"></i> <i>{{breadName}}</i>
        </div>
    </div>
</template>
<script>
export default {
    props:['breadName'],
     methods: {
        goback(){
            this.$emit('breadback')
            // this.$router.push('/')
        }
    },
}
</script>
<style scoped>
    .detaioBread{
        width: 100%;
        height: 60px;
        background: #FFFFFF;
        box-shadow: 0px 1px 0px 0px #EEEEEE;
        border-bottom: 1px solid #EEEEEE;;
    }
    .detaioBread_{
        width: 1126px;
        height: 100%;
        margin: 0px auto;
        line-height: 60px;
        font-size: 14px;
        font-weight: 400;
        color: #A4AFBC;
        letter-spacing: 1px;
        padding-left: 11px;
        box-sizing: border-box;
    }
    .detaioBread_>em{
        cursor: pointer;
    }
    .detaioBread_>span{
        display: inline-block;
        width: 5px;
        height: 10px;
        background: #A4AFBC;
        margin: 0 6px;
    }
    .detaioBread_>i{
        font-style: normal;
        font-weight: 500;
        color: #3D7FFF;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/detailBread.vue